import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AnonymousModalAccount = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-family: ${Fonts['light']};
  font-size: ${26 * Screen.widthRatio}px;
  position: absolute;
  top: ${-54 * Screen.widthRatio}px;
`;

export default AnonymousModalAccount;
